/* 🤖 this file was generated by svg-to-ts*/
export const icoForbidden: {
  name: 'forbidden';
  data: string;
} = {
  name: 'forbidden',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM5.68 7.095A8 8 0 0016.905 18.32L5.678 7.096zM12 4c-1.848 0-3.55.627-4.905 1.68L18.32 16.905A8 8 0 0012 4z" fill="#909090"/></svg>`
};
